import React, { useState, useEffect } from "react";
//outsource
import { Row, Col, Modal, Calendar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  snapAllCashup,
  unSnapAllCashup,
} from "../../../store/cashup/cashup.action";
import { detailBranchSelector } from "../../../store/branch/branch.selector";
import { setDate } from "../../../store/var/var.action";
import { dateSelector } from "../../../store/var/var.selector";
import { setDateLabel } from "../../../store/var/var.action";
import moment from "moment";
//components

const format = "DD/MM/YYYY";

const DialogDateSelect = ({ open, setOpen }) => {
  // -------------------------- VAR --------------------------
  const [data, setData] = useState([]);
  // console.log({ data });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const branch = useSelector(detailBranchSelector);
  const date = useSelector(dateSelector);

  // -------------------------- FUNCTION ------------------------
  const handleChange = (date) => {
    dispatch(setDate({ data: date }));
    dispatch(setDateLabel({ data: date?.format("DD/MM/YYYY") }));
    setOpen(false);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (branch) {
      dispatch(
        snapAllCashup({ branch: branch?.id }, (res) => {
          if (res === false) {
            setData([]);
          } else {
            setData(res);
          }
        })
      );
    }
  }, [dispatch, branch]);
  // -------------------------- RENDER --------------------------
  const cellRender = (current) => {
    const currentString = current && current?.format(format);
    const target = data?.find((item) => {
      const dateString = item?.date;
      return currentString === dateString;
    });
    const status = target?.status;

    if (status === "confirmed") {
      return (
        <div className="events">
          <div className="confirm">Confirmed</div>
        </div>
      );
    }

    if (status === "unconfirmed") {
      return (
        <div className="events">
          <div className="warning-confirm">To be confirmed</div>
        </div>
      );
    }

    return (
      <div className="events">
        {/* <div className="unconfirm"></div> */}
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Modal
      title="Date Cashup"
      width={800}
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <Calendar
        fullscreen={true}
        mode="month"
        dateCellRender={cellRender}
        onChange={handleChange}
        value={date}
        disabledDate={(current) => {
          return current && current > moment();
        }}
      />
    </Modal>
  );
};

export default DialogDateSelect;
